import $ from 'jquery';

$(document).ready(function(){

    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true,

    }).on('changeDate', function(e) {
        $(".date").children("input:text").val(e.format());
    });
});

